<template>
  <div class="sky-ai-knowledge">
    <div class="ai-buttons">
      <el-tooltip content="有问题？点这里！" placement="left" ref="tooltip" popper-class="arrow-tooltip">
        <el-button type="danger" @click="handleClick">
          <i class="el-icon-question" style="font-size: 18px;">
            <font style="font-size: 14px;font-weight: bold;">云桌面智能问答系统</font>
          </i>
        </el-button>
      </el-tooltip>
    </div>
  </div>
</template>
<script type="text/babel">
import { Button, Tooltip } from 'element-ui'

export default {
  name: 'SkyAIKnowledge',
  inject: ['rootView', 'elForm'],
  components: {
    [Button.name]: Button,
    [Tooltip.name]: Tooltip
  },
  props: {
    isGuidePage: {
      // 接收父组件传递的状态
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  watch: {
    isGuidePage(newVal) {
      // 监听状态变化
      if (newVal) {
        this.clearTimers()
      } else {
        this.initTooltip()
      }
    }
  },
  mounted() {
    this.initTooltip()
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },

  methods: {
    initTooltip() {
      if (this.isGuidePage) {
        // 仅在非引导页启动闪烁
        this.interval = setInterval(() => {
          this.$refs.tooltip.show()
          setTimeout(() => this.$refs.tooltip.hide(), 1500)
        }, 2500)

        // 首次立即触发
        this.$refs.tooltip.show()
        setTimeout(() => this.$refs.tooltip.hide(), 1500)
      }
    },
    handleClick() {
      window.open('http://140.224.74.115:8080/login/', '_blank')
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(ai-knowledge) {
  & .ai-buttons {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  & .el-button {
    width: 100%;
    font-size: 14px;
    padding: 10px 10px;
    border-radius: 25px;
    white-space: nowrap; // 防止文字换行
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.blink-tooltip {
  &.el-tooltip__popper {
    /* 恢复默认样式 */
    background: #000 !important;
    color: #fff !important;

    /* 移除箭头自定义颜色 */
    &[x-placement^='left'] .popper__arrow {
      border-left-color: #000 !important;
      &:after {
        border-left-color: #000 !important;
      }
    }

    /* 移除图标 */
    &::before {
      content: none !important;
    }
  }
}

.arrow-tooltip {
  &.el-tooltip__popper {
    background: #000 !important;
    color: white !important;
    border: none !important;
    box-shadow: 0 2px 12px rgba(64, 158, 255, 0.2);
    transform-origin: right center; // 设置动画原点
    animation: arrow-show 0.3s ease-out;

    &[x-placement^='left'] .popper__arrow {
      border-left-color: #000 !important;
      &:after {
        border-left-color: #000 !important;
      }
    }

    /* 添加箭头效果 */
    &::before {
      content: ''; // 向右箭头
      position: absolute;
      right: -16px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 18px;
      color: #409eff;
      opacity: 0;
      animation: arrow-fade-in 0.3s ease-out forwards;
    }
  }
}

/* Tooltip整体移动动画 */
@keyframes arrow-show {
  from {
    transform: translateX(-10px); // 初始位置偏左
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* 箭头淡入动画 */
@keyframes arrow-fade-in {
  from {
    opacity: 0;
    transform: translateX(-10px) translateY(-50%);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(-50%);
  }
}
</style>
